import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Button,
  TableRow,
  Box,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
  Pagination
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm, FormProvider } from "react-hook-form";
import AddNotes from "./AddNotes";
import { deleteNoteActionById } from "../../redux/actions/noteActions";
import { getPolicySearchPolicyListAction } from '../../redux/actions/policyActions';
import { getNotesListDataAction } from "../../redux/actions/customerSearchAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader/loader";
import AddNoteButton from "./AddNoteButton";
import { CustomTableCell } from '../../common/CustomTableCell';
import NoDataFound from "../../common/NoDataFound";

const AddNotesTable = ({ notes,
  hasSearched,
  getNewPolicyNumber,
  getNewPolicyId, newpolicyId,
  notesPolicyId,
  getPolicyNumber,
  customerId,
  selectedOption,
  selectedPolicyId ,
  selected_customer_list,
  }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showNote, setShowNote] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const dispatch = useDispatch();
  const [editPolicy, setEditPolicy] = useState(false);
  const [getNoteId, setGetNoteId] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
  const [userToDelete, setUserToDelete] = useState(null);
  const [noteType, setNoteType] = useState("");
  const [editData, setEditData] = useState([]);

  const customer_id = useSelector((state) => state?.customerDetails?.client_customer_id || null);
  const note_button = useSelector((state) => state?.policy?.saved_policy_data || null);

  const notesValue = useSelector((state) => state?.note?.allNote) || {
    content: [],
    totalElements: 0,
    number: 0,
    size: 5
  };

  const notesData = notesValue.content || [];
  const searchNotesData = notes?.content || [];

  const dataToDisplay = hasSearched ? searchNotesData : notesData;
  const totalCount = hasSearched ? (notes?.totalElements || 0) : (notesValue.totalElements || 0);

  const methods = useForm();
  const { setValue } = methods;

  const fetchNotes = useCallback(async () => {
    try {
      setShowLoader(true);
      if (selectedOption === "All" || getNewPolicyNumber) {
        const finalId=customerId?customerId:customer_id;
          dispatch(getNotesListDataAction(finalId, page, rowsPerPage));
         }
       else if (selectedOption === "Policies" && selectedPolicyId) {
           dispatch(getPolicySearchPolicyListAction(selectedPolicyId, page, rowsPerPage));
        }
    } catch (error) {
      console.error('Error fetching notes:', error);
    } finally {
      setShowLoader(false);
    }
  }, [dispatch, notesPolicyId,selectedPolicyId, customerId, page, rowsPerPage]);

  // useEffect(() => {
  //   fetchNotes();
  // }, [fetchNotes]);

  useEffect(()=>{
    setPage(0);
  },[selectedOption])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditClick = (note) => {
    setEditData(note)
    setShowNote(true);
    setGetNoteId(note.id);
    setShowButton(false);
    setEditPolicy(true);
    setNoteType(note.type || "");
    setValue("policyNumber", note.policyNumber || "");
    setValue("notesSource", note.notesSource || "");
    setValue("message", note.message || "");
  };

  const handleDeleteClick = (id) => {
    setUserToDelete(id);
    setOpenConfirmationDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setShowLoader(true);
      await dispatch(deleteNoteActionById(userToDelete));
      setDeleteSuccessMessage("Note deleted successfully!");
      await fetchNotes();
    } catch (error) {
      console.error('Error deleting note:', error);
    } finally {
      setShowLoader(false);
      setOpenConfirmationDialog(false);
      setTimeout(() => setDeleteSuccessMessage(""), 3000);
    }
  };

  const handleClick = () => {
    setShowNote(true);
    setShowButton(true);
  };

  return (
    <FormProvider {...methods}>
      <Box>
        {showNote && (
          <AddNotes
            editData={editData}
            showButton={showButton}
            getNewPolicyNumber={getNewPolicyNumber}
            getNewPolicyId={getNewPolicyId}
            setShowNote={setShowNote}
            getPolicyNumber={getPolicyNumber}
            notesPolicyId={notesPolicyId}
            getNoteId={getNoteId}
            editPolicy={editPolicy}
            newpolicyId={newpolicyId}
            onNotesUpdated={fetchNotes}
            noteType={noteType}
            customerId={customerId}
            selected_customer_list={selected_customer_list}
            selectedPolicyId={selectedPolicyId}
            selectedOption={selectedOption}
          />
        )}

        {note_button && (
         <Box sx={{ display: "flex", flexDirection: "column", padding: '0 20px 20px 20px', boxSizing: 'border-box', justifyContent: 'end', alignItems: 'end' }}>
            <AddNoteButton handleClick={handleClick} />
         </Box>
        )}


        <Box sx={{ display: "flex", flexDirection: "column", padding: '0 20px 20px 20px', boxSizing: 'border-box', alignItems: "center" }}>
          <TableContainer component={Paper}>
            <Table aria-label="notes table">
              <TableHead>
                <TableRow>
                  {!customerId && <TableCell className="styled-table-heading">Policy Number</TableCell>}
                  <TableCell className="styled-table-heading">Created By</TableCell>
                  <TableCell className="styled-table-heading">Created Date</TableCell>
                  <TableCell className="styled-table-heading">User Id</TableCell>
                  <TableCell className="styled-table-heading">Notes</TableCell>
                  <TableCell className="styled-table-heading">Updated By</TableCell>
                  <TableCell className="styled-table-heading">Note Type</TableCell>
                  <TableCell align="right" className="styled-table-heading">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {showLoader ? (
                  <TableRow>
                    <TableCell colSpan={customerId ? 4 : 5} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : dataToDisplay.length > 0 ? (
                  dataToDisplay?.map((row, index) => (
                    <TableRow key={index} className="styled-table-row">
                      {!customerId && <TableCell>{row.policyNumber}</TableCell>}
                      <TableCell>{row.createdBy?.name || '-'}</TableCell>
                      <CustomTableCell timestamp={row.createdBy?.timestamp} />

                      <TableCell>{row.notesSource}</TableCell>
                      <TableCell>{row.message}</TableCell>
                       <TableCell>{row.updatedBy?.name || '-'}</TableCell>
                      <TableCell>{row.type}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleEditClick(row)} color="primary">
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDeleteClick(row.id)} color="primary">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <NoDataFound/>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {totalCount > 0 && (
              <Box sx={{ display: "flex",justifyContent:"flex-end", alignItems: "center", padding: "1rem" }}>
                <span style={{ marginRight: 8, fontSize: '14px' }}>Rows per page:</span>
                <Box>
                  <select
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    style={{ padding: '6px 12px', borderRadius: '4px', borderColor: '#ccc' }}
                  >
                    {[5, 10, 15].map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </Box>

                <Pagination
                  count={Math.ceil(totalCount / rowsPerPage)}
                  page={page + 1} 
                  onChange={(event, value) => handleChangePage(event, value - 1)} 
                  showFirstButton
                  showLastButton

                />
              </Box>
            )}
          </TableContainer>
        </Box>

        <Dialog
          open={openConfirmationDialog}
          onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setOpenConfirmationDialog(false); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableScrollLock={true}
          keepMounted={false}
          hideBackdrop={false}
          style={{ zIndex: 1300 }}

        >
          <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ marginTop: 5 }}>
              Are you sure you want to delete this note? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenConfirmationDialog(false)}
              variant="outlined"
              size="large"
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              variant="outlined"
              size="large"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={deleteSuccessMessage !== ""}
          autoHideDuration={3000}
          onClose={() => setDeleteSuccessMessage("")}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert onClose={() => setDeleteSuccessMessage("")} severity="success">
            {deleteSuccessMessage}
          </Alert>
        </Snackbar>
      </Box>
    </FormProvider>
  );
};

export default AddNotesTable;